<div class="flag-resolve-topbar">
  <div class="tabs-section">
    <div class="tabs-container">
      <div
        *ngFor="let tab of tabs"
        class="tab-item"
        [class.selected]="tab.isSelected"
        [class.disabled]="tab.count === 0"
        (click)="onTabClick(tab.key)">
        <div class="tab-content">
          <span class="tab-label">{{ tab.label }}</span>
          <div class="tab-count">{{ tab.count }}</div>
        </div>
        <div class="tab-indicator" *ngIf="tab.isSelected"></div>
      </div>
    </div>
  </div>

  <div class="actions-section">
    <div class="progress-container">
      <div class="progress-text">{{ resolvedFlags }}/{{ totalFlags }} flags</div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width]="progressBarWidth"></div>
      </div>
      <div class="progress-percentage">{{ progressPercentage }}%</div>
    </div>
  </div>
</div>
